import React from 'react';
import { Level } from 'rbx';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import Can from '../../../utils/Can';
import { ACLSConsumer } from '../../../utils/aclsContext';

const Wrapper = styled.div`
  padding: 0rem 1rem;
  padding-bottom: 1rem;
`;

const Footer = ({ loading, handleSubmit, back, location }) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Level.Item>
          <button onClick={back} className="button is-light">
            <span>Cancel</span>
          </button>
        </Level.Item>
      </Level.Item>
      <Level.Item align="right">
        <ACLSConsumer>
          {({ apiActions, pageActions }) => (
            <Can
              action={`${
                location.pathname === '/event-fee-override'
                  ? 'update_place'
                  : 'update_place'
              }`}
              apiActions={apiActions}
              pageActions={pageActions}
              yes={() => (
                <Level.Item>
                  <button
                    className={`button is-primary ${loading && 'is-loading'}`}
                    onClick={handleSubmit}
                  >
                    <span>Submit</span>
                  </button>
                </Level.Item>
              )}
            />
          )}
        </ACLSConsumer>
      </Level.Item>
    </Level>
  </Wrapper>
);

export default withRouter(Footer);
